/**
 * Rejeições benignas do ApexCharts quando o DOM é removido ou trocado
 * (navegação, v-if) — evita ruído no Sentry sem mascarar outros erros.
 */
function messageFromHint(hint) {
    const ex = hint?.originalException;
    if (typeof ex === 'string') return ex;
    if (ex && typeof ex === 'object') {
        if (typeof ex.message === 'string') return ex.message;
        if (ex.reason && typeof ex.reason.message === 'string') return ex.reason.message;
    }
    return '';
}

function stackFromHint(hint) {
    const ex = hint?.originalException;
    if (ex && typeof ex === 'object' && typeof ex.stack === 'string') return ex.stack;
    if (hint?.syntheticException && typeof hint.syntheticException.stack === 'string') {
        return hint.syntheticException.stack;
    }
    return '';
}

function framesMentionApexcharts(event) {
    const values = event?.exception?.values;
    if (!Array.isArray(values)) return false;
    for (const v of values) {
        const frames = v?.stacktrace?.frames;
        if (!Array.isArray(frames)) continue;
        if (
            frames.some((f) => {
                const bundle = `${f?.filename || ''} ${f?.abs_path || ''} ${f?.module || ''}`.toLowerCase();
                return bundle.includes('apexcharts');
            })
        ) {
            return true;
        }
    }
    return false;
}

export function isBenignApexChartsElementNotFound(event, hint) {
    const fromHint = messageFromHint(hint);
    const fromEvent = event?.exception?.values?.map((v) => v?.value).filter(Boolean).join(' ') || '';
    const msg = `${fromHint} ${fromEvent}`;
    if (!msg.includes('Element not found')) return false;

    const stack = `${stackFromHint(hint)}`;
    if (stack.toLowerCase().includes('apexcharts')) return true;
    return framesMentionApexcharts(event);
}

/**
 * @type {import('@sentry/vue').BrowserOptions['beforeSend']}
 */
export function sentryBeforeSend(event, hint) {
    if (isBenignApexChartsElementNotFound(event, hint)) {
        return null;
    }
    return event;
}
